module.exports = __webpack_public_path__ + "img/xing.4485296.png";